import React from "react";
import { Button, Grid, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function MissingConsumer({ consumerId }: { consumerId: number }) {
  const navigate = useNavigate();

  const handleGoToConsumer = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate("/consumers");
  };

  if (consumerId !== 0) return null;

  return (
    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: "calc(100vh - 170px)" }}>
      <Paper
        elevation={4}
        sx={{
          textAlign: "center",
          padding: 4,
          maxWidth: 400,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="h4" component="h4">
          Consumer is missing in selection!
        </Typography>
        <Button variant="contained" color="primary" onClick={handleGoToConsumer}>
          Go To Consumers
        </Button>
      </Paper>
    </Grid>
  );
}
